import React from 'react';
import { FormattedMessage } from 'react-intl';

import Hidden from '@material-ui/core/Hidden';

class PanelInfo extends React.Component {
    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    render() {
        const { id, is50 } = this.props;
        return (
            <Hidden xsDown>
                <div className={is50 ? 'flex_50 center' : 'flex_full height100 center'}>
                    <div className={'flex_full center height100 bg_cloudy_blue_30'}>
                        <span
                            className={
                                'padding_borders flex_full center barlow_medium c_dark_grey_blue'
                            }
                        >
                            <FormattedMessage id={id} />
                        </span>
                    </div>
                </div>
            </Hidden>
        );
    }
}

export default PanelInfo;



// WEBPACK FOOTER //
// ./src/components/labels/PanelInfo.js